@if (!!lineOptions?.length) {
@if (selection) {
<p class="p2 col-11 m-b-1">{{lineAttribute.code | attributeLabel}}: {{selection.label}}</p>
}
@for (option of lineOptions; track $index) {
<box class="inline-block va-m cursor-pointer m-t-1 m-r-1"
     [configurableOptionWarningTrigger]="{ attribute: lineAttribute, option: option }"
     [selected]="isPicked(lineAttribute, option)"
     [disabled]="isDisabled(option) || option.product?.isNotifyMe"
     [warning]="hasWarning(option)"
     (click)="pick(lineAttribute, option)">
    {{ option.label }}
</box>
}
}
